enum DroneShotIntegrationStatus {
  active = 'active',
  archived = 'archived',
  deleted = 'deleted',
}

export default DroneShotIntegrationStatus
